/* TWRD 2026-10-15: Instafeed popup, fit + step navigation (progressive).
   1) Desktop: sizes the popup to the media's own aspect, so 4:5 and 1:1
      posts get no black bars and the panel is exactly as tall as the media.
   2) Wheel / trackpad, touch swipe on the media and arrow keys step to the
      next or previous post by clicking the app's OWN next/prev controls.
   Only acts while an Instafeed popup is open. App JS is untouched. */
(function () {
  'use strict';
  if (window.__twrdIgNav) return;
  window.__twrdIgNav = true;

  var DESKTOP_MIN = 1025;
  var PANEL_W = 405;
  var SIDE_GUTTER = 128;
  var MAX_H = 860;
  var STEP_LOCK_MS = 450;
  var GESTURE_QUIET_MS = 220;
  var SWIPE_PX = 40;
  var DEFAULT_RATIO = 9 / 16;

  /* ---------- helpers ---------- */
  function isShown(node) {
    if (!node) return false;
    var cs = getComputedStyle(node);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && node.getClientRects().length > 0;
  }

  /* Same visibility test as the controls (display, visibility, client rects),
     so a closed popup never hijacks wheel or arrow keys. */
  function openLightbox() {
    var all = document.querySelectorAll('.instafeed-modals-wrapper .instafeed-lightbox');
    for (var i = 0; i < all.length; i++) {
      if (isShown(all[i])) return all[i];
    }
    return null;
  }

  /* ---------- 1) fit to media aspect ---------- */
  function mediaRatio(box) {
    var wrap = box.querySelector('.instafeed-post-image');
    if (!wrap) return null;
    var video = wrap.querySelector('video');
    if (video && video.videoWidth && video.videoHeight) return video.videoWidth / video.videoHeight;
    var img = wrap.querySelector('img');
    var real = img && img.currentSrc && !/placeholder/i.test(img.currentSrc);
    if (real && img.naturalWidth && img.naturalHeight) return img.naturalWidth / img.naturalHeight;
    if (video) return DEFAULT_RATIO;
    return null;
  }

  function watchMedia(box) {
    var wrap = box.querySelector('.instafeed-post-image');
    if (!wrap || wrap.__twrdFitWatch) return;
    wrap.__twrdFitWatch = true;
    var refit = function () { fit(box); };
    wrap.addEventListener('load', refit, true);
    wrap.addEventListener('loadedmetadata', refit, true);
  }

  function clearFit(box) {
    if (!box.classList.contains('twrd-ig-fit')) return;
    box.classList.remove('twrd-ig-fit');
    box.style.removeProperty('--twrd-mh');
    box.style.removeProperty('--twrd-mw');
  }

  function fit(box) {
    watchMedia(box);
    if (window.innerWidth < DESKTOP_MIN) { clearFit(box); return; }
    var ratio = mediaRatio(box);
    if (!ratio) { clearFit(box); return; }
    var maxH = Math.min(window.innerHeight * 0.9, MAX_H);
    var maxW = window.innerWidth - SIDE_GUTTER - PANEL_W;
    if (maxW < 200) { clearFit(box); return; }
    var h = maxH;
    var w = h * ratio;
    if (w > maxW) { w = maxW; h = w / ratio; }
    var mh = Math.round(h) + 'px';
    var mw = Math.round(w) + 'px';
    /* Only write on change: these writes are observed (style attribute). */
    if (box.style.getPropertyValue('--twrd-mh') !== mh) box.style.setProperty('--twrd-mh', mh);
    if (box.style.getPropertyValue('--twrd-mw') !== mw) box.style.setProperty('--twrd-mw', mw);
    if (!box.classList.contains('twrd-ig-fit')) box.classList.add('twrd-ig-fit');
  }

  function fitAll() {
    var boxes = document.querySelectorAll('.instafeed-modals-wrapper .lightbox-instagram');
    for (var i = 0; i < boxes.length; i++) {
      try { fit(boxes[i]); } catch (e) { /* keep the app layout */ }
    }
  }

  /* ---------- 2) step navigation ---------- */
  var lockUntil = 0;

  function control(lb, dir) {
    var sels = dir > 0
      ? ['.instafeed-new-arrow.next', '.instafeed-bottom-bar .instafeed-post-control-button.arrow-down', '.instafeed-post-control-button.arrow-down']
      : ['.instafeed-new-arrow.prev', '.instafeed-bottom-bar .instafeed-post-control-button.arrow-up', '.instafeed-post-control-button.arrow-up'];
    for (var i = 0; i < sels.length; i++) {
      var n = lb.querySelector(sels[i]);
      if (n && isShown(n)) return n;
    }
    return null;
  }

  function step(dir) {
    var now = Date.now();
    if (now < lockUntil) return true;
    var lb = openLightbox();
    var btn = lb && control(lb, dir);
    if (!btn) return false;
    lockUntil = now + STEP_LOCK_MS;
    btn.click();
    return true;
  }

  /* Does an element between target and the popup still have room to scroll? */
  function canScroll(target, lb, dx, dy) {
    for (var n = target; n && n !== lb && n.nodeType === 1; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (dy) {
        var oy = cs.overflowY;
        if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) {
          if (dy > 0 && n.scrollTop + n.clientHeight < n.scrollHeight - 1) return true;
          if (dy < 0 && n.scrollTop > 0) return true;
        }
      }
      if (dx) {
        var ox = cs.overflowX;
        if ((ox === 'auto' || ox === 'scroll') && n.scrollWidth > n.clientWidth + 1) {
          if (dx > 0 && n.scrollLeft + n.clientWidth < n.scrollWidth - 1) return true;
          if (dx < 0 && n.scrollLeft > 0) return true;
        }
      }
    }
    return false;
  }

  var gestureTimer = null;
  var inGesture = false;

  function onWheel(e) {
    var lb = openLightbox();
    if (!lb || !lb.contains(e.target)) return;
    var dx = e.deltaX;
    var dy = e.deltaY;
    var horizontal = Math.abs(dx) > Math.abs(dy);
    var delta = horizontal ? dx : dy;
    if (Math.abs(delta) < 4) return;
    if (canScroll(e.target, lb, horizontal ? dx : 0, horizontal ? 0 : dy)) return;
    e.preventDefault();
    /* One gesture = one step: trackpad momentum keeps firing, so wait for quiet. */
    clearTimeout(gestureTimer);
    gestureTimer = setTimeout(function () { inGesture = false; }, GESTURE_QUIET_MS);
    if (inGesture) return;
    inGesture = true;
    step(delta > 0 ? 1 : -1);
  }

  var touch = null;

  function onTouchStart(e) {
    var lb = openLightbox();
    if (!lb || e.touches.length !== 1) { touch = null; return; }
    var media = e.target.closest && e.target.closest('.instafeed-post-image');
    if (!media || !lb.contains(media)) { touch = null; return; }
    touch = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }

  function onTouchEnd(e) {
    if (!touch) return;
    var t = e.changedTouches && e.changedTouches[0];
    var start = touch;
    touch = null;
    if (!t) return;
    var dx = t.clientX - start.x;
    var dy = t.clientY - start.y;
    if (Math.abs(dx) < SWIPE_PX || Math.abs(dx) < Math.abs(dy)) return;
    step(dx < 0 ? 1 : -1);
  }

  function captionCanScroll(target, lb, dy) {
    if (target && target.nodeType === 1 && lb.contains(target) && canScroll(target, lb, 0, dy)) return true;
    var areas = lb.querySelectorAll('.instafeed-caption, .description');
    for (var i = 0; i < areas.length; i++) {
      if (canScroll(areas[i], lb, 0, dy)) return true;
    }
    return false;
  }

  function onKey(e) {
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
    var k = e.key;
    if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'ArrowUp' && k !== 'ArrowDown') return;
    var lb = openLightbox();
    if (!lb) return;
    var tag = (e.target && e.target.tagName) || '';
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(tag) || (e.target && e.target.isContentEditable)) return;
    /* The app also maps Left/Right, but its script is loaded more than once on
       this page, so one press stepped several posts. Handle all four arrows here
       (window capture runs first) and stop the app's duplicate handlers. */
    var dir = (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : -1;
    /* Up/Down: let the browser scroll a long caption first. */
    if ((k === 'ArrowUp' || k === 'ArrowDown') && captionCanScroll(e.target, lb, dir)) return;
    if (step(dir)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  /* ---------- init ---------- */
  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 120);
  }

  /* The non-passive wheel listener blocks scroll optimisation, so it is only
     attached while a popup is open. Re-checked on every observed change. */
  var wheelOn = false;
  function syncWheel() {
    var open = !!openLightbox();
    if (open === wheelOn) return;
    wheelOn = open;
    if (open) document.addEventListener('wheel', onWheel, { passive: false });
    else document.removeEventListener('wheel', onWheel, { passive: false });
  }

  var fitQueued = false;
  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    requestAnimationFrame(function () {
      fitQueued = false;
      fitAll();
      syncWheel();
    });
  }

  function watchWrapper(w) {
    if (w.__twrdIgNavWatched) return;
    w.__twrdIgNavWatched = true;
    queueFit();
    /* style: the app shows a post by changing the lightbox's inline display. */
    new MutationObserver(queueFit).observe(w, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'src'] });
  }

  function watchAll() {
    var ws = document.querySelectorAll('.instafeed-modals-wrapper');
    for (var i = 0; i < ws.length; i++) watchWrapper(ws[i]);
  }

  function init() {
    if (!document.body) return;
    if (window.MutationObserver) {
      watchAll();
      new MutationObserver(watchAll).observe(document.body, { childList: true });
    }
    window.addEventListener('resize', onResize, { passive: true });
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('keydown', onKey, true);
    /* The app can open or close the popup without a mutation inside the
       watched wrapper, so re-check the wheel state after any click or key. */
    var resync = function () { setTimeout(syncWheel, 350); setTimeout(syncWheel, 1000); };
    document.addEventListener('click', resync, { capture: true, passive: true });
    document.addEventListener('keyup', resync, { capture: true, passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
